import { Pipe, PipeTransform } from '@angular/core';
import { ReportName } from '../../../../shared/enums/report-name.enum';

@Pipe({
  name: 'isReportType',
  standalone: true,
})
export class IsReportTypePipe implements PipeTransform {
  transform(value: ReportName | null | undefined, type: ReportName): boolean {
    return value === type;
  }
}
